import Head from "next/head";
import styles from "../styles/Home.module.css";
import Header from "../local_components/Header";
import Footer from "../local_components/Footer";

import {
  useStoryblokState,
  getStoryblokApi,
  StoryblokComponent,
} from "@storyblok/react";

export default function Page({ story }) {
  story = useStoryblokState(story);

  return (
    <div className={styles.container}>
      <Head>

        <link rel="icon" href="/favicon.ico" />
      </Head>

    <Header />

      <StoryblokComponent blok={story.content} />

      <Footer />
    </div>
  );
}

/* export async function getStaticProps({ params }) {
  let slug = params.slug ? params.slug.join("/") : "home";

  let sbParams = {
    version: process.env.IS_PROD ? "published" : "draft"
  };

  const storyblokApi = getStoryblokApi();
  let { data } = await storyblokApi.get(`cdn/stories/${slug}`, sbParams);

  return {
    props: {
      story: data ? data.story : false,
      key: data ? data.story.id : false,
    },
  };
}

export async function getStaticPaths() {
  const storyblokApi = getStoryblokApi();
  let { data } = await storyblokApi.get("cdn/links/");

  let paths = [];
  Object.keys(data.links).forEach((linkKey) => {
     if (data.links[linkKey].slug !== "marken-und-biere" && data.links[linkKey].slug !== "service-und-seminare" && data.links[linkKey].slug !== "schanktechnik-und-bierpflege") {
      return;
    } 

    const slug = data.links[linkKey].slug;
    let splittedSlug = slug.split("/");

    paths.push({ params: { slug: splittedSlug } });
  });

  return {
    paths: paths,
    fallback: false,
  };
} */


export async function getStaticProps({ params }) {
  let subpageSlug = params.slug ? params.slug[0] : "home"; // Das letzte Element der Slug-Reihenfolge verwenden

  let sbParams = {
    version: process.env.IS_PROD ? "published" : "draft"
  };

  const storyblokApi = getStoryblokApi();
  let { data } = await storyblokApi.get(`cdn/stories/${subpageSlug}`, sbParams);

  return {
    props: {
      story: data ? data.story : false,
      key: data ? data.story.id : false,
    },
  };
}

export async function getStaticPaths() {
  const storyblokApi = getStoryblokApi();
  let { data } = await storyblokApi.get("cdn/links/");

  let paths = [];
  Object.keys(data.links).forEach((linkKey) => {
    const slug = data.links[linkKey].slug;
    let splittedSlug = slug.split("/");

    // Hier entfernen Sie die Ordner aus der Slug-Reihenfolge, indem Sie nur das letzte Element behalten
    const subpageSlug = splittedSlug[splittedSlug.length - 1];
    
    paths.push({ params: { slug: [subpageSlug] } });
  });

  return {
    paths: paths,
    fallback: false,
  };
}
